import React, { useContext, useEffect, useState } from 'react'
import PriceSlider from '../filters/PriceSlider'
import { Grid, IconButton, Typography } from '@mui/material'
import { CloseOutlined, PowerSettingsNew, RestartAlt } from '@mui/icons-material'
import { Box } from '@mui/system'

import { Context as FilterContext } from '../context/FilterContext'
import Shape from '../filters/Shape'
import TagsFilterWrapper from './TagsFilterWrapper'


const Filters = ({ reset, refresh, maxPrice, tags, categories, category, resetCategory }) => {
    const { changeFilterValue } = useContext(FilterContext)

    const [price, setPrice] = useState(null);
    const [shape, setShape] = useState(null)
    const [activeFilters, setActiveFilters] = useState(null)

    const resetTargetAndFilters = () => {
        setPrice(null)
        setShape(null)
        setActiveFilters(null)
        reset()
    }

    const resetFilters = () => {
        setPrice(null)
        setShape(null)
        setActiveFilters({})
    }

    useEffect(() => {
        changeFilterValue('Tags', activeFilters)
        changeFilterValue('Price', price)
        changeFilterValue('Shape', shape)
    }, [price, shape, activeFilters])

    return (
        <div style={{ backgroundColor: 'white', display: 'flex', justifyContent: 'center', paddingTop: 30, paddingBottom: 25 }}>
            <Grid container spacing={0} justifyContent="flex-end" id='visidea-custom-filters'>
                <Grid item xs={6} sm={6} md={4} lg={4}>
                    <Box style={{ display: 'flex' }} justifyContent="flex-end" flexDirection='row' id='visidea-custom-buttons'>
                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', marginRight: 5 }}>
                            <IconButton size="large" title='Refresh' onClick={() => refresh(true)}>
                                <RestartAlt fontSize="inherit" />
                            </IconButton>
                            <Typography fontSize={15}>Refresh</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', marginRight: 5 }}>
                            <IconButton size="large" title='Restart' onClick={() => resetTargetAndFilters()}>
                                <PowerSettingsNew fontSize="inherit" />
                            </IconButton>
                            <Typography fontSize={15}>Restart</Typography>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={6} md={4} lg={4} justifyContent="flex-end">
                    <Box sx={{ display: 'flex' }} justifyContent="flex-end" flexDirection='row' id='visidea-custom-shape'>
                        <Shape setShape={setShape} shape={shape} />
                    </Box>
                </Grid>
                <Grid item xs={6} sm={6} md={4} lg={4} justifyContent="flex-start">
                    {/* <Box sx={{ display: 'flex', paddingTop: 1.1 }} justifyContent="flex-start" flexDirection='row' id='tags'> */}
                    <Box sx={{ display: 'flex', paddingLeft: 5 }} justifyContent="flex-start" flexDirection='row' id='visidea-custom-tags'>
                        <TagsFilterWrapper
                            setActiveFilters={setActiveFilters}
                            tags={tags}
                            categories={categories}
                            resetCategory={resetCategory}
                            reset={resetFilters} 
                            category={category}
                        />
                    </Box>
                </Grid>
            </Grid>
        </div>
    )
}

export default Filters